import { render, staticRenderFns } from "./MarqueeRolln1.vue?vue&type=template&id=1e8dee24&scoped=true"
import script from "./MarqueeRolln1.vue?vue&type=script&lang=js"
export * from "./MarqueeRolln1.vue?vue&type=script&lang=js"
import style0 from "./MarqueeRolln1.vue?vue&type=style&index=0&id=1e8dee24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8dee24",
  null
  
)

export default component.exports